import { onAuthStateChanged } from "firebase/auth"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import logo from "../assets/icon.png"
import { auth } from "../functions/firebase"

export default function SplashScreen() {

    const navigate = useNavigate()

    useEffect(() => {

        onAuthStateChanged(auth, {
            next: user => {

                setTimeout(() => {
                    if(user) {
                    
                        if(!user?.displayName) {
    
                            navigate("/auth-1/" + user.uid + "/configuration")
    
                        } else {
    
                            navigate("/auth-1/" + user.uid)
    
                        }
    
                    } else {
                        navigate("/getting-started")
                    }
                }, 2000)

            },
            error: err => {
                

            }
        })

    }, [])

    return (
        <div style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            backgroundColor: "var(--background)",
        }}>
            <img src={logo} alt=""
                style={{
                    width: "200px",
                    aspectRatio: 1,
                    objectFit: "cover"
                }}
            />
            <p>Please wait...</p>
        </div>
    )
}